import React from 'react';
import { Link } from 'react-router-dom';
import { Label } from 'office-ui-fabric-react';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';

import SurveyTemplateService from '../services/SurveyTemplateService'
import SurveyService from '../services/SurveyService'
import Survey from '../models/SurveyModel';
import FilteredMultiSelection from '../common/FilteredMultiSelection'

import { sortByOrder, getSelectedTemplates, getDataFromState, requiredFieldNames, templateDefaultFieldNames } from '../common/Utilities';

import '../App.css';

class SelectProperties extends React.Component {

    constructor(props) {
        super(props);

        const sharedState = { ...props.data };
        sharedState.selectedTemplates = getSelectedTemplates(props.data.survey);
        // Get the key of the first item in the array
        sharedState.selectedTemplateKey = sharedState.selectedTemplateKey === "" ? sharedState.selectedTemplates[0] : sharedState.selectedTemplateKey;
        const localState = {

            hasChanges: false,

            // Array to hold all of the items (field names) that will be displayed in the list
            //_allItems: [this.fieldNames(selectedTemplates[0])],

            // Array to hold all of the items with the filter applied
            _availableTemplateItems: {},

            //this.state._availableTemplateItems[this.state.selectedTemplateKey] = this.state._allItems.sort(sortByLabel);
            selectedTemplatesChosenFields: {}
        };
        this.state = { ...sharedState, ...localState };

        // Do any deletions from the survey templates if the selection was changed
        // for (let i=this.state.survey.Templates.L.length-1; i>=0; i--) {
        //     if (this.state.selectedTemplates.filter(t => t === this.state.survey.Templates.L[i].M.Value.S).length === 0) {
        //         this.state.survey.Templates.L.splice(i,1);
        //     }
        // };

    }

    templates = null;

    async componentDidMount() {

        this.templates = this.props.data.templates;
        if (this.templates.length === 0) {
            const db = new SurveyTemplateService();
            this.templates = await db.scan();            
            this.setState(this.setState({ templates: this.templates }));
            this.props.updateCommonState(getDataFromState(this.state));
        }

        // Add all fields that are in the existing survey Templates collection to the
        // selectedTemplatesChosen fields collection
        // it is an object that has one property for each template
        // selectedTemplatesChosenFields.templateName = [field1, 2, 3,...]
        const selectedTemplatesChosenFields = this.state.survey.getChosenFields(this.state.templates,
            this.state.selectedTemplatesChosenFields);

        // for any templates that weren't saved, create a collection of required / template default
        // fields for each template that was selected
        this.state.selectedTemplates.forEach(item => {
            if (selectedTemplatesChosenFields[item].length === 0) {
                const cf = requiredFieldNames(this.state.templates,item)
                    .concat(templateDefaultFieldNames(this.state.templates,item));
                if (cf.length > 0) {
                    selectedTemplatesChosenFields[item] = cf;
                    // Initalize the template in the survey so available fields include the
                    // requiredColumns
                    this.state.survey.setColumnsFromTemplate(cf, this.state.templates.filter(t => t.value === item)[0]);
                    // set the has changes flag because this will have been a new survey with
                    // the required and default properties added. If someone clicks save it should
                    // be ready to use without additional modifications
                    this.setState({ hasChanges: true });
                }
            }
        });

        // this.state.selectedTemplatesChosenFields[this.state.selectedTemplateKey] = [];
        // set the selected options if the collection exists in the chosen fields collection
        if (selectedTemplatesChosenFields[this.state.selectedTemplateKey]) {
            this.setState({ selectedOptions: selectedTemplatesChosenFields[this.state.selectedTemplateKey] });
        }
        //}

        // The selection length can change through use of previous / next of the wizard
        // The full list of selected templates is checked to add / remove items
        const available = this.state._availableTemplateItems;
        let keyNames = Object.keys(available);
        keyNames.forEach((key) => {
            // if the key in our state doesn't exist in the currently selected set, delete it
            if (this.state.selectedTemplates.filter((item) => item === key).length === 0) {
                delete available[key];
                // maybe leave them so someone doesn't lose work by removing then adding the template
                // delete this.state.selectedTemplateFields[key];
            }
        });

        // Now add any new templates that were added
        this.state.selectedTemplates.forEach((key) => {
            if (!available[key]) {
                available[key] = this.fieldNames(key);
                // Sort by label so the selection list is easy to use
                //available[key].sort(sortByLabel); - decided to leave them in order

                // On a new add initialize the selected key as a collection to hold the selected fields
                if (!selectedTemplatesChosenFields[key]) {
                    selectedTemplatesChosenFields[key] = [];
                }
            }
        });

        // Validate that the selectedKey exists, if not, change it to the first one in the list
        if (this.state.selectedTemplates.filter((item) => item === this.state.selectedTemplateKey).length === 0) {
            delete available[this.state.selectedTemplateKey];
            this.setState({
                selectedTemplateKey: this.state.selectedTemplates[0],
                // Set the selected set to the new key
                selectedOptions: selectedTemplatesChosenFields[this.state.selectedTemplateKey]
            });
        }

        this.setState({
            selectedTemplatesChosenFields: selectedTemplatesChosenFields,
            _availableTemplateItems: available
        });
    }

    saveRecordOnly = () => {
        this.saveChanges(0);
    };
    saveAndNext = () => {
        this.saveChanges(1);
    };
    saveAndPrevious = () => {
        this.saveChanges(-1);
    };

    saveChanges = (moveTo) => {
        //console.log(this.state.survey);
        if (this.state.hasChanges) {
            // Set the timestamp before saving. It's a new record - 
            // this tells when it was updated and not to validate if a user does a back and changes something
            const timeStamp = (new Date()).toISOString();
            let survey = { ...this.state.survey }
            survey["schemaDTS"] = timeStamp;
            this.setState({ survey: survey }, () => {
                // Save the survey
                const db = new SurveyService();
                db.put(new Survey().fromSimple(survey).getDbObject(), this.state.templates);
                this.props.onSave(getDataFromState(this.state), moveTo);
            });
        } else {
            if (moveTo !== 0) { this.props.moveTo(moveTo); }
        }
        this.setState({ hasChanges: false });
        this.props.onSurveyChange(false);
    }

    updateSurveyTemplate = () => {
        // Once the selection list has changed push the changes into the survey record
        // This record gets saved and is used in the column configuration on the next screen

        // // the selected template key must exist in the templates collection
        const template = this.state.templates.filter(t => t.value === this.state.selectedTemplateKey)[0];

        // Set columns from selected options collection
        this.state.survey.setColumnsFromTemplate(this.state.selectedOptions, template);
    };

    handleDeselect = (deselectedOptions) => {
        let selectedOptions = this.state.selectedOptions.slice();
        deselectedOptions.forEach(option => {
            selectedOptions.splice(selectedOptions.indexOf(option), 1);
        })
        const selected = this.state.selectedTemplatesChosenFields;
        selected[this.state.selectedTemplateKey] = selectedOptions;

        this.setState({ selectedOptions: selectedOptions, selectedTemplatesChosenFields: selected, hasChanges: true },
            this.updateSurveyTemplate);
        this.props.onSurveyChange(true);
    };

    handleSelect = (selectedOptions) => {
        selectedOptions.sort(sortByOrder);
         this.setState({ selectedOptions: selectedOptions });
        const selected = this.state.selectedTemplatesChosenFields;
        selected[this.state.selectedTemplateKey] = selectedOptions;
        this.setState({ selectedOptions: selectedOptions, selectedTemplatesChosenFields: selected, hasChanges: true },
            this.updateSurveyTemplate);
        this.props.onSurveyChange(true);
    };

    templateLabel = (value) => {
        const item = this.state.templates.find((item) => item.value === value);
        return item ? item.label : `Error - Template ${value} not found`;
    };

    templateLabels = () => {
        return this.state.selectedTemplates.map(item => {
            return { key: item, text: this.templateLabel(item) };
        });
    };

    onTemplateChange = (e, option, index, value) => {
        if (option !== undefined) {
            this.setState({
                selectedTemplateKey: option.key,
                selectedOptions: this.state.selectedTemplatesChosenFields[option.key]
            }, () => { console.log(this.state.selectedTemplateKey); console.log(this.state.selectedOptions); });
        }
    };

    templateNameStyles = () => {
        return {
            root: {
                fontSize: '14pt'
            }
        };
    };

    fieldNames = (key) => {
        //const names = this.state.templates[this.state.selectedTemplateIndex].columns.map((item) => item.M);
        const template = this.templates.filter((item) => item.value === key)[0];
        const columns = template.columns.concat(template.templateDefaultColumns);
        return columns.map(
            (item) => {
                return {
                    Label: item.M.Label.S, ColumnName: item.M.ColumnName.S,
                    required: item.M.RequiredColumn.BOOL,
                    templateDefault:  item.M.TemplateDefault.BOOL,
                    nullable: item.M.Nullable.BOOL,
                    isSeparator: item.M.DataType.S === "Separator",
                    displayOrder: parseInt(item.M.DisplayOrder.N, 10)
                }
            });
    };
    render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-10">
                        <h2 className="heading" >Select Properties</h2>
                        <div style={{ marginTop: "25px" }}>

                        </div>
                        <div style={{ marginTop: "25px" }}>
                            {
                                (this.state.selectedTemplates.length === 1) ?
                                    <Label styles={this.templateNameStyles}>{this.templateLabel(this.state.selectedTemplates[0])}</Label> :
                                    <ComboBox
                                        selectedKey={this.state.selectedTemplateKey}
                                        allowFreeform={false}
                                        autoComplete="off"
                                        onChange={this.onTemplateChange}
                                        options={this.templateLabels()}
                                    />
                            }
                        </div>
                        <div className="row" style={{ marginTop: "25px" }}>
                            <div className="col-xs-6">
                                {this.state._availableTemplateItems[this.state.selectedTemplateKey] &&
                                    <FilteredMultiSelection
                                        buttonText="Add"
                                        classNames={{
                                            filter: 'form-control',
                                            select: 'form-control filter-select-box',
                                            button: 'btn btn-block btn-default',
                                            buttonActive: 'btn btn-block btn-primary'
                                        }}
                                        onChange={this.handleSelect}
                                        options={this.state._availableTemplateItems[this.state.selectedTemplateKey]}
                                        selectedOptions={this.state.selectedOptions}
                                        textProp="Label"
                                        valueProp="ColumnName"
                                        requiredProp="required"
                                    />
                                }
                            </div>
                            <div className="col-xs-6">
                                <FilteredMultiSelection
                                    buttonText="Remove"
                                    classNames={{
                                        filter: 'form-control',
                                        select: 'form-control filter-select-box',
                                        button: 'btn btn-block btn-default',
                                        buttonActive: 'btn btn-block btn-danger'
                                    }}
                                    onChange={this.handleDeselect}
                                    options={this.state.selectedOptions}
                                    textProp="Label"
                                    valueProp="ColumnName"
                                    requiredProp="required"
                                    allowSeparatorSelection={false}
                                />
                            </div>
                        </div>
                        <div className="buttonRow" style={{ marginTop: "15px" }}>
                            <div>
                                <button style={{ 'fontSize': '12px', 'color': '#676767' }} type="button" onClick={this.saveAndPrevious} className="btn btn-default">Previous</button>
                            </div>
                            <div>
                                <button style={{ 'fontSize': '12px', 'color': '#676767' }} type="button" onClick={this.saveAndNext} className="btn btn-default">Next</button>
                            </div>
                            <div>
                                <button style={{ 'fontSize': '12px', 'color': '#676767' }} type="button" onClick={this.saveRecordOnly} className="btn btn-default">Save</button>
                            </div>
                            <div>
                                <button style={{ 'fontSize': '12px', 'color': '#676767' }} type="button" className="btn btn-default">Undo Changes</button>
                            </div>
                            <div>
                                <Link to="/">
                                    <button style={{ 'fontSize': '12px', 'color': '#676767' }} className="btn btn-default">Home</button>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-1 col-md-2 col-lg-3"></div>
                </div>
            </div>

        );
    }
}

export default SelectProperties;
